import {getApp, getApps, initializeApp} from 'firebase/app';
import {getFirestore} from 'firebase/firestore';
import {getStorage} from 'firebase/storage';

const firebaseConfig = {    
    apiKey: "AIzaSyAA-VzWDb9lV6G3eHqlvyRNwjeg9T9BGmw",
    authDomain: "eventos-dulcefiesta.firebaseapp.com",
    databaseURL: "https://eventos-dulcefiesta-default-rtdb.firebaseio.com",
    projectId: "eventos-dulcefiesta",
    storageBucket: "eventos-dulcefiesta.appspot.com",
    messagingSenderId: "329883185588",
    appId: "1:329883185588:web:a696a12f42816058e442e1"
  };

  const app = getApps.Lenght > 0 ? getApp() : initializeApp(firebaseConfig);

  const firestore = getFirestore(app);
  const storage = getStorage(app);

  export {app, firestore, storage};